import { InstructionsCtrl } from './instructions.controller';

export const InstructionsStepComponent = {
  controller: InstructionsCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./instructions.html'),
};
